export const DEFAULT_AVATAR_URL = 'https://iupac.org/wp-content/uploads/2018/05/default-avatar.png';

export enum SchoolPaths {
  school = "school",
  personal = "personalSchool",
}

export const acceptedImageTypes = '.jpg,.jpeg,.png';